//#region INTERFACE IStoreOverrideSettings
export interface IStoreOverrideSettings {
  /**
   * Default max items when creating stock takes (filter / uncounted) or schedules.
   * Absent → app default ({@link STOCK_TAKE_DEFAULT_BASE_ITEM_LIMIT}); hard max remains 500.
   */
  defaultMaxItemLimit?: number;
  /**
   * Default for new stock takes / schedule runs.
   * Absent or true → Del-Col included; false → Del-Col excluded by default.
   */
  includeDelColDefault?: boolean;
  orderBlankSupplierCode?: boolean;
  shelfTalkersEnabled?: boolean;
}

//#endregion